import React from 'react';
import { Modal,Button} from 'rsuite';
class VideoModal extends React.Component {
    constructor(props) {
      super(props);
    }
    render() {
        return (
            <Modal show={this.props.showvideo} onHide={this.props.videoclose} size="lg" overflow>
                <Modal.Header>
                    <Modal.Title>视频说明</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <video width="900" height="380" id="video" controls>
                    <source src="/assets/video/info.mp4" type="video/mp4"/>
                    </video>   
                </Modal.Body>
                {/* <Modal.Footer>
                    <Button onClick={this.props.videoclose} style={{textAlign:"center"}} appearance="primary">
                    关闭
                    </Button>
                </Modal.Footer> */}
            </Modal>
        )
        
    }
}
export default VideoModal;